<div class="pointer-events-none fixed right-4 top-4 z-[120] flex w-[min(24rem,calc(100vw-2rem))] flex-col gap-3">
  <ng-container *ngFor="let toast of toasts$ | async; trackBy: trackToast">
    <div
      class="pointer-events-auto relative overflow-hidden rounded-3xl border shadow-[0_20px_50px_rgba(27,16,52,0.12)] backdrop-blur-xl"
      [ngClass]="toneClasses(toast.type)"
    >
      <div class="absolute inset-y-0 left-0 w-1 bg-gradient-to-b" [ngClass]="accentClasses(toast.type)"></div>
      <div class="flex items-start gap-4 px-5 py-4">
        <div
          class="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ring-1"
          [ngClass]="badgeClasses(toast.type)"
        >
          <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="iconPath(toast.type)"></path>
          </svg>
        </div>

        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2">
            <span class="text-sm font-semibold text-brand-ink">{{ toast.title }}</span>
            <span class="rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.2em] ring-1" [ngClass]="badgeClasses(toast.type)">
              {{ iconLabel(toast.type) }}
            </span>
          </div>
          <p class="mt-1 text-sm leading-5 text-brand-ink-secondary">{{ toast.message }}</p>
        </div>

        <button
          *ngIf="toast.dismissible"
          type="button"
          class="rounded-full p-2 text-brand-muted transition hover:bg-white/70 hover:text-brand-ink"
          (click)="dismissToast(toast.id)"
          aria-label="Cerrar alerta"
        >
          <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 6l12 12M18 6L6 18"></path>
          </svg>
        </button>
      </div>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="confirm$ | async as confirmState">
  <div class="fixed inset-0 z-[130] bg-[rgba(27,16,52,0.44)] backdrop-blur-sm"></div>
  <div class="fixed inset-0 z-[131] flex items-center justify-center p-4">
    <div class="w-full max-w-md overflow-hidden rounded-[2rem] border border-brand-subtle bg-brand-surface-card shadow-[0_30px_80px_rgba(27,16,52,0.22)]">
      <div class="bg-[linear-gradient(135deg,rgba(54,22,129,0.10)_0%,rgba(51,102,255,0.08)_100%)] px-6 py-6">
        <div class="flex items-start gap-4">
          <div
            class="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl ring-1"
            [ngClass]="badgeClasses(confirmState.type)"
          >
            <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="iconPath(confirmState.type)"></path>
            </svg>
          </div>
          <div>
            <p class="text-xs font-semibold uppercase tracking-[0.3em] text-brand-muted-light">
              {{ isWarning(confirmState) ? 'Confirmacion' : 'Mensaje' }}
            </p>
            <h3 class="mt-2 text-xl font-semibold text-brand-ink">{{ confirmState.title }}</h3>
            <p class="mt-3 text-sm leading-6 text-brand-ink-secondary">{{ confirmState.message }}</p>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end gap-3 px-6 py-5">
        <button
          type="button"
          class="rounded-2xl border border-brand-subtle bg-brand-surface px-4 py-2.5 text-sm font-semibold text-brand-ink-secondary transition hover:bg-brand-surface-raised"
          (click)="cancel()"
        >
          {{ confirmState.cancelText }}
        </button>
        <button
          type="button"
          class="rounded-2xl bg-brand-accent px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-accent-hover"
          (click)="confirm()"
        >
          {{ confirmState.confirmText }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
